import { getDeviceInfo, myOrderList, myPendingOrderList } from "@/apis/market";
import { getAnnouncement } from "@/apis/user";
import { getHomePagePopupInfo } from "@/apis/common";
import { useConfigContext } from "@/app";
import { DialogLocal } from "@/components/Dialog";
import { LINK_ACCOUNT_TOKEN } from "@/constants";
import { StateActions, useCreateReducer } from "@/libs/reducer";
import { useUserInfoStore } from "@/stores/userInfo";
import { PendingOrder } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { Order } from "@/types/Api/Order";
import { useCreation, useMount } from "ahooks";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import { Swiper, Tabs, Dialog } from "antd-mobile";
import { SwiperRef } from 'antd-mobile/es/components/swiper';
import { HomepagePopupType } from "@/types/Api/Common/Home/getConfig";
export type Announcement = {
  content: any;
  contentId?: string;
};
export interface PageState {
  orderList: PendingOrder[];
  orderTotal: number;
  tradeTotal: number;
  tradeList: Order[];
  unReadCount: number;
  announcement: Announcement[];
  homePopupList: HomepagePopupType[];
}
const pagestate = {
  orderList: [],
  orderTotal: 0,
  tradeTotal: 0,
  tradeList: [],
  unReadCount: 0,
  announcement: [],
  homePopupList: []
};
export const stateReducer = (state: PageState, action: StateActions<PageState>): PageState => {
  switch (action.type) {
    case "fetch_pending_orderList":
      return Object.assign({}, state, {
        orderList: action?.orderList,
        orderTotal: action?.orderTotal
      });
    case "fetch_trade_orderList":
      return Object.assign({}, state, {
        tradeList: action?.tradeList,
        tradeTotal: action?.tradeTotal
      });
    case "get_unread_count":
      return Object.assign({}, state, {
        unReadCount: action?.unReadCount
      });
    case "get_announcement":
      return Object.assign({}, state, {
        announcement: action?.announcement
      });
    case "fetch_home_popup_List":
      return Object.assign({}, state, {
        homePopupList: action?.homePopupList
      });
    default:
      return state;
  }
};

// 初始化
export const useLogic = () => {
  const navigate = useNavigate();
  const [userInfo, updateUserInfo] = useUserInfoStore()(state => [state.userInfo, state.updateUserInfo]);
  const {
    config,
    getSourcePath
  } = useConfigContext();
  const [state, dispatch] = useCreateReducer<PageState>(stateReducer, pagestate, {
    orderList: [],
    tradeList: [],
    unReadCount: 0,
    announcement: [],
    homePopupList: []
  });
  const [visible, setVisible] = useState(false);
  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sureIndex, setSureIndex] = useState(0);

  // 通告内容
  const announcements = useCreation(() => {
    return state.announcement.map(item => item.content);
  }, [state.announcement]);

  // 用户名称
  const userName = useCreation(() => {
    return userInfo.nickname || userInfo.userName || userInfo.realName;
  }, [userInfo]);

  // 用户
  const userAvatar = useCreation(() => {
    return getSourcePath(userInfo.avatar);
  }, [getSourcePath, userInfo.avatar]);
  const fetchPendingOrderList = async () => {
    const response = await myPendingOrderList({
      page: 1,
      pageSize: 5
    });
    if (response.ok) {
      dispatch({
        type: "fetch_pending_orderList",
        orderList: response.data.list,
        orderTotal: response.data.total
      });
    } else {
      // TODO: 请求失败的处理
    }
  };
  const fetchTradeOrderList = async () => {
    const response = await myOrderList({
      page: 1,
      pageSize: 5
    });
    if (response.ok) {
      dispatch({
        type: "fetch_trade_orderList",
        tradeList: response.data?.list || [],
        tradeTotal: response.data?.total || 0
      });
    } else {
      // TODO: 请求失败的处理
    }
  };
  const getCommonAnnouncement = async () => {
    const response = await getAnnouncement({});
    if (response.ok) {
      dispatch({
        type: "get_announcement",
        announcement: response.data.list
      });
    } else {
      // TODO: 请求失败的处理
    }
  };
  const fetchHomePagePopupInfo = async () => {
    const res = await getHomePagePopupInfo();
    if (res.ok) {
      setVisible(true);
      dispatch({
        type: "fetch_home_popup_List",
        homePopupList: res.data || []
      });
    } else {
      // TODO: 请求失败的处理
    }
  };
  const renderSwiper = () => {
    return <Dialog visible={visible} content={<div className={styles.swiperBox}>
            <Tabs className={styles.tabs} activeKey={String(activeIndex)} onChange={key => {
        setActiveIndex(Number(key));
        swiperRef.current?.swipeTo(Number(key));
      }}>
              {state.homePopupList.map((item: HomepagePopupType, i: number) => <Tabs.Tab title={item.title} key={i} />)}
            </Tabs>
            <div className={styles.swiperWrap}>
              <Swiper ref={swiperRef} indicator={() => null} defaultIndex={activeIndex} onIndexChange={index => {
          setActiveIndex(index);
        }}>
                {state.homePopupList.map((val: HomepagePopupType, i: number) => {
            return <Swiper.Item key={i}>
                    <div dangerouslySetInnerHTML={{
                __html: val.content || ''
              }} />
                  </Swiper.Item>;
          })}
              </Swiper>
            </div>
            
        </div>} closeOnAction={false} onClose={() => {
      setVisible(false);
    }} onAction={async () => {
      if (sureIndex + 1 < state.homePopupList.length) {
        let goIndex = activeIndex === sureIndex ? sureIndex + 1 : 0;
        setSureIndex(goIndex);
        setActiveIndex(Number(goIndex));
        swiperRef.current?.swipeTo(Number(goIndex));
      } else {
        setVisible(false);
        setSureIndex(0);
      }
    }} actions={[{
      key: 'confirm',
      text: '确定',
      className: styles.btnColor
    }]} data-sentry-element="Dialog" data-sentry-component="renderSwiper" data-sentry-source-file="logic.tsx" />;
  };
  const onTabChange = (key: string) => {
    if (`${key}` === "1") {
      fetchPendingOrderList();
    }
    if (`${key}` === "2") {
      fetchTradeOrderList();
    }
  };
  const vipyUserCheck = async () => {
    const response = await getDeviceInfo({});
    if (response.code === 1001) {
      navigate('/user_check');
    }
  };
  useMount(() => {
    const domainSearch = new URLSearchParams(window.location.search);
    let vipy = '';
    if (domainSearch.has("vipy")) {
      vipy = domainSearch.get("vipy") || '';
    }
    console.log('vipy==', vipy);
    if (window.localStorage[LINK_ACCOUNT_TOKEN]) {
      if (userInfo) {
        if (userInfo.secPasswordStatus) {
          // 已设置资金密码,但是还没有授权，跳转授权
          navigate('/link_account');
          return;
        }
      }
      DialogLocal({
        closeOnMaskClick: false,
        title: "提示",
        content: <div style={{
          color: "#FB2222",
          textAlign: "center"
        }}>
            为了您的账户安全,请立即设置资金密码
          </div>,
        onConfirm() {
          navigate('/user_pay_psw');
        }
      });
      return;
    }
    if (userInfo && !userInfo.isEnteredPassword) {
      DialogLocal({
        closeOnMaskClick: false,
        title: "提示",
        content: <div style={{
          color: "#FB2222",
          textAlign: "center"
        }}>
            为了您的账户安全,请设置登录密码
          </div>,
        onConfirm() {
          navigate('/user_login_psw');
        }
      });
      return;
    } else {
      //内嵌 vipy1  需要调接口校验用户设备
      if (vipy === '1') {
        vipyUserCheck();
      }
    }
    fetchHomePagePopupInfo(); //首页弹窗
    getCommonAnnouncement();
    // fetchTradeOrderList();
    fetchPendingOrderList();
    if (config?.alertAnn && config.alertAnn.status === "1") {
      DialogLocal({
        closeOnMaskClick: false,
        title: config.alertAnn.title || "通知",
        content: <RichTextRender text={config.alertAnn.content} />
      });
    }
  });
  return {
    userInfo,
    userName,
    userAvatar,
    tradeList: state.tradeList,
    tradeTotal: state.tradeTotal,
    orderTotal: state.orderTotal,
    orderList: state.orderList,
    announcements,
    onTabChange,
    updateUserInfo,
    renderSwiper
  };
};
const RichTextRender = ({
  text
}: {
  text: string;
}) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const isHTMLIFrameElement = (ele: HTMLIFrameElement | null): ele is HTMLIFrameElement => {
    return ele !== null;
  };
  const writeIframe = (ele: HTMLIFrameElement | null) => {
    if (isHTMLIFrameElement(ele) && ele.contentDocument) {
      const iframeBody = ele.contentDocument.body;
      if (iframeBody) {
        iframeBody.innerHTML = text;
        console.info("iframe body");
      } else {
        console.error("iframe body not found");
      }
    } else {
      console.error("iframe not found");
    }
  };
  useEffect(() => {
    writeIframe(ref.current);
  }, [text]);
  useMount(() => {
    const ele = (ref.current! as HTMLIFrameElement);
    if (isHTMLIFrameElement(ele) && ele.contentDocument) {
      const iframeBody = ele.contentDocument.body;
      if (iframeBody) {
        iframeBody.innerHTML = text;
        console.info("useMount::iframe body");
      } else {
        console.error("useMount::iframe body not found");
      }
    } else {
      console.error("useMount::iframe not found");
    }
  });
  return <iframe ref={ref} className={styles.iframe} title="公告" onLoad={e => {
    writeIframe((e.target as HTMLIFrameElement));
  }} data-sentry-component="RichTextRender" data-sentry-source-file="logic.tsx" />;
};